import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'store/appStore';
import { fetchMeta } from 'action/surveyAction';
import { selectDistributionSlug } from 'selector/navigationSelector';

export const useFetchMeta = () => {
  const dispatch = useAppDispatch();
  const slug = useSelector(selectDistributionSlug);

  useEffect(() => {
    if (slug) {
      dispatch(fetchMeta());
    }
  }, [slug, dispatch]);
};
